import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DummyCubeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.4199 5.77L12.3296 1.3262C12.1216 1.2246 11.8784 1.2246 11.6704 1.3262L2.57961 5.77C2.32231 5.896 2.15921 6.1572 2.15921 6.4438V17.5556C2.15921 17.8417 2.32231 18.1035 2.57961 18.2294L11.6704 22.6737C11.7744 22.7245 11.8872 22.7499 12 22.7499C12.1128 22.7499 12.2256 22.7245 12.3296 22.6737L21.4199 18.2294C21.6777 18.1034 21.8408 17.8417 21.8408 17.5556V6.4438C21.8408 6.1572 21.6777 5.8959 21.4199 5.77ZM12 2.835L19.8381 6.6664L12 10.4995L4.16161 6.6665L12 2.835ZM3.65921 7.5341L11.5 11.3683V20.9207L3.65921 17.0879V7.5341ZM12.5 20.9207V11.3683L20.3408 7.5339V17.0879L12.5 20.9207Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

DummyCubeIcon.displayName = 'DummyCubeIcon';
